export const hasAnyCapability = (capabilities, candidates) => candidates.some((capability) => capabilities.includes(capability));

export const getVisibleBusinessTabs = (capabilities = [], canManageMembers = false) => {
  const tabs = ['overview', 'projects', 'people'];
  if (hasAnyCapability(capabilities, [
    'funding.view', 'funding.manage',
    'accounting.view', 'accounting.manage',
    'reporting.view', 'reporting.manage',
  ])) {
    tabs.push('money');
  }
  if (canManageMembers || hasAnyCapability(capabilities, ['domain.manage', 'address.manage'])) {
    tabs.push('more');
  }
  return tabs;
};